var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c(
        "md-layout",
        {
          attrs: { id: "help-icon" },
          nativeOn: {
            mouseover: function($event) {
              return _vm.showInstructions.apply(null, arguments)
            },
            mouseout: function($event) {
              return _vm.hideInstructions.apply(null, arguments)
            }
          }
        },
        [_c("md-icon", { attrs: { "md-iconset": "fa fa-info-circle" } })],
        1
      ),
      _vm.isAlertVisible
        ? _c("div", { staticClass: "help-alert" }, [
            _c("p", [
              _vm._v(
                "If you change the playlist, this may cause changes in the Categories, please review them before Updating"
              )
            ])
          ])
        : _vm._e(),
      _c(
        "md-layout",
        { staticClass: "md-headline", attrs: { "md-align": "center" } },
        [_vm._v("Sections")]
      ),
      _c("edit-or-new-section", {
        ref: "popUpSection",
        attrs: { entity: _vm.entity, "playlist-items": _vm.playlistItems },
        on: { currentsections: _vm.currentSections }
      }),
      _c(
        "md-layout",
        { attrs: { "md-flex": "100" } },
        [
          _c(
            "SlickList",
            {
              staticClass: "container-sections",
              class: { "sections-list": _vm.loading },
              attrs: { "md-align": "center" },
              model: {
                value: _vm.entity.sections,
                callback: function($$v) {
                  _vm.$set(_vm.entity, "sections", $$v)
                },
                expression: "entity.sections"
              }
            },
            [
              _c("Loader", {
                staticClass: "loader-icon",
                attrs: { loading: _vm.loading }
              }),
              _vm._l(_vm.entity.sections, function(section, index) {
                return _c(
                  "SlickItem",
                  {
                    key: section.name,
                    staticClass: "sections",
                    class: {
                      "disabled-section": !section.visible,
                      "most-popular-section": _vm.isMostPopular(section)
                    },
                    attrs: { index: index }
                  },
                  [
                    _c("div", { staticClass: "info-section" }, [
                      _c(
                        "div",
                        { staticClass: "titleMenu" },
                        [
                          _c("h3", { staticClass: "title-section" }, [
                            _vm._v(
                              " " +
                                _vm._s(index + 1) +
                                " - " +
                                _vm._s(section.name)
                            )
                          ]),
                          section.type === "playlist"
                            ? _c(
                                "p",
                                {
                                  staticClass: "title-section",
                                  class: {
                                    "series-section":
                                      section.type === "playlist"
                                  }
                                },
                                [_vm._v("Series")]
                              )
                            : _vm._e(),
                          _vm.hasProblem(section)
                            ? _c(
                                "md-icon",
                                {
                                  staticClass: "md-icon icon-warning",
                                  attrs: {
                                    "md-iconset": "fa fa-exclamation-triangle"
                                  }
                                },
                                [
                                  _c(
                                    "md-tooltip",
                                    { staticClass: "tooltip-warning" },
                                    [
                                      _vm._v(
                                        "Some series in this section do not exist in the current playlist"
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "info-btn-section" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "statusInfo",
                              class: { "live-status": section.visible }
                            },
                            [_vm._v(_vm._s(section.visible ? "LIVE" : "DRAFT"))]
                          ),
                          _c("md-switch", {
                            model: {
                              value: section.visible,
                              callback: function($$v) {
                                _vm.$set(section, "visible", $$v)
                              },
                              expression: "section.visible"
                            }
                          }),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button",
                              attrs: {
                                id: "btn",
                                disabled: _vm.isMostPopular(section)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeSection(index, section.name)
                                }
                              }
                            },
                            [
                              _c("md-icon", {
                                class: {
                                  "disabled-icon": _vm.isMostPopular(section)
                                },
                                attrs: {
                                  id: "md-icon-section",
                                  "md-iconset": "fa fa-trash-alt"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-icon-button",
                              attrs: { id: "btn" },
                              on: {
                                click: function($event) {
                                  return _vm.editSection(index, section)
                                }
                              }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  id: "md-icon-section",
                                  "md-iconset": "fa fa-pencil-alt"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    section.type !== "playlist"
                      ? _c(
                          "div",
                          { staticClass: "sectContainer" },
                          _vm._l(section.tagsAssociated, function(section) {
                            return _c("p", { staticClass: "sect" }, [
                              _vm._v(_vm._s(section))
                            ])
                          }),
                          0
                        )
                      : _c(
                          "div",
                          { staticClass: "sectContainer" },
                          _vm._l(section.seriesAssociated, function(section) {
                            return _c("p", { staticClass: "sect" }, [
                              _vm._v(
                                _vm._s(
                                  section.name
                                    ? section.name
                                    : _vm.associatedSeries.filter(function(
                                        serie
                                      ) {
                                        return serie._id === section
                                      })[0].name
                                )
                              )
                            ])
                          }),
                          0
                        )
                  ]
                )
              }),
              _c(
                "div",
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary md-raised",
                      nativeOn: {
                        click: function($event) {
                          return _vm.addNewSection.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("Add Section")]
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1144ba2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1144ba2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/distribution/form-components/Sections.vue
// module id = 815
// module chunks = 0